export const COLUMNS = [
  {
    title: '序号',
    width: 70,
    dataIndex: 'receivingListIndex',
    customRender: (text, record, index) => {
      return index + 1;
    },
    stickyFixed: 'left'
  },
  {
    title: '供应商',
    width: 200,
    dataIndex: 'factoryName',
    scopedSlots: { customRender: 'factoryName' },
    stickyFixed: 'left'
  },
  {
    title: '供应商仓',
    width: 120,
    dataIndex: 'factoryWarehouseName',
    scopedSlots: { customRender: 'factoryWarehouseName' }
  },
  {
    title: '单车装载体积',
    width: 100,
    dataIndex: 'presetLoadVolume',
    scopedSlots: { customRender: 'presetLoadVolume' }
  },
  {
    title: '增减货前-总需求体积',
    width: 140,
    dataIndex: 'beforeTotalVolume',
    scopedSlots: { customRender: 'beforeTotalVolume' }
  },
  {
    title: '增减货后-总需求体积',
    width: 140,
    dataIndex: 'totalVolume',
    scopedSlots: { customRender: 'totalVolume' }
  },
  {
    title: '增减货前-车载率',
    width: 140,
    dataIndex: 'beforeLoadRate',
    scopedSlots: { customRender: 'beforeLoadRate' },
    sorter: true,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '增减货后-车载率',
    width: 140,
    dataIndex: 'loadRate',
    scopedSlots: { customRender: 'loadRate' },
    sorter: true,
    sortDirections: ['ascend', 'descend']
  },
  {
    title: '增减货前-车次',
    width: 120,
    dataIndex: 'beforeDriveCount',
    scopedSlots: { customRender: 'beforeDriveCount' }
  },
  {
    title: '增减货后-车次',
    width: 120,
    dataIndex: 'driveCount',
    scopedSlots: { customRender: 'driveCount' }
  },
  {
    title: '要求到仓日期',
    width: 100,
    dataIndex: 'requireDeliveryDay',
    scopedSlots: { customRender: 'requireDeliveryDay' }
  },
  {
    title: '早晚班标识',
    width: 100,
    dataIndex: 'earlyMorningDeliveryIs',
    scopedSlots: { customRender: 'earlyMorningDeliveryIs' }
  },
  {
    title: '是否仓库卸货',
    width: 100,
    dataIndex: 'dischargeIs',
    scopedSlots: { customRender: 'dischargeIs' }
  },
  {
    title: '入库仓库',
    width: 80,
    dataIndex: 'warehouseName',
    scopedSlots: { customRender: 'warehouseName' }
  },
  {
    title: '当天欠货',
    width: 100,
    dataIndex: 'currentDayUnderShipmentQty'
  },
  {
    title: '7天欠货',
    width: 80,
    dataIndex: 'sevenDayUnderShipmentQty',
    scopedSlots: { customRender: 'sevenDayUnderShipmentQty' }
  },
  {
    title: '14天欠货',
    width: 80,
    dataIndex: 'fourteenDayUnderShipmentQty',
    scopedSlots: { customRender: 'fourteenDayUnderShipmentQty' }
  },
  {
    title: '21天欠货',
    width: 80,
    dataIndex: 'twentyOneDayUnderShipmentQty',
    scopedSlots: { customRender: 'twentyOneDayUnderShipmentQty' }
  },
  {
    title: '28天欠货',
    width: 80,
    dataIndex: 'twentyEightDayUnderShipmentQty',
    scopedSlots: { customRender: 'twentyEightDayUnderShipmentQty' }
  },
  {
    title: '调度员',
    width: 100,
    dataIndex: 'dispatcherName',
    scopedSlots: { customRender: 'dispatcherName' }
  },
  {
    title: '采购员',
    width: 100,
    dataIndex: 'purchaseUserName',
    scopedSlots: { customRender: 'purchaseUserName' }
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'dataCreateTime',
    scopedSlots: { customRender: 'dataCreateTime' }
  }
]

export const COLUMNS_DETAIL = [
  {
    title: '序号',
    width: 70,
    dataIndex: 'receivingIndex',
    customRender: (text, record, index) => {
      return index + 1;
    },
    stickyFixed: 'left'
  },
  {
    title: '供应商',
    width: 200,
    dataIndex: 'factoryName',
    scopedSlots: { customRender: 'factoryName' },
    ellipsis: true,
    stickyFixed: 'left'
  },
  // {
  //   title: '计划单号',
  //   width: 100,
  //   dataIndex: 'billNo',
  //   scopedSlots: { customRender: 'billNo' }
  // },
  // {
  //   title: '增货计划单',
  //   width: 100,
  //   dataIndex: 'parentBillNo',
  //   scopedSlots: { customRender: 'parentBillNo' }
  // },
  // {
  //   title: '增货-送货单',
  //   width: 100,
  //   dataIndex: 'parentReceiptBillNo',
  //   scopedSlots: { customRender: 'parentReceiptBillNo' }
  // },
  // {
  //   title: '单据状态',
  //   width: 100,
  //   dataIndex: 'status',
  //   scopedSlots: { customRender: 'status' }
  // },
  // {
  //   title: '完成状态',
  //   width: 100,
  //   dataIndex: 'completeStatus',
  //   scopedSlots: { customRender: 'completeStatus' }
  // },
  {
    title: '物料编码',
    width: 140,
    dataIndex: 'materialNo',
    scopedSlots: { customRender: 'materialNo' },
    stickyFixed: 'left'
  },
  {
    title: '物料名称',
    width: 100,
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' }
  },
  {
    title: '规格描述',
    width: 200,
    dataIndex: 'materialSpec',
    scopedSlots: { customRender: 'materialSpec' },
    ellipsis: true
  },
  {
    title: '增减货标识',
    width: 100,
    dataIndex: 'loadAddIs',
    scopedSlots: { customRender: 'loadAddIs' }
  },
  {
    title: '增减货前-总需求体积',
    width: 140,
    dataIndex: 'beforeTotalVolume',
    scopedSlots: { customRender: 'totalVolume' }
  },
  {
    title: '增减货后-总需求体积',
    width: 140,
    dataIndex: 'totalVolume',
    scopedSlots: { customRender: 'totalVolume' }
  },
  {
    title: '增减货前-要求到仓数量',
    width: 150,
    dataIndex: 'beforeRequireDeliveryQuantity',
    scopedSlots: { customRender: 'beforeRequireDeliveryQuantity' }
  },
  {
    title: '增减货后-要求到仓数量',
    width: 150,
    dataIndex: 'requireDeliveryQuantity',
    scopedSlots: { customRender: 'requireDeliveryQuantity' }
  },
  // {
  //   title: '增货数量',
  //   width: 100,
  //   dataIndex: 'supplementQuantity',
  //   scopedSlots: { customRender: 'supplementQuantity' }
  // },
  // {
  //   title: '审核数量',
  //   width: 100,
  //   dataIndex: 'auditQuantity',
  //   scopedSlots: { customRender: 'auditQuantity' }
  // },
  {
    title: '当前订单满足率',
    width: 100,
    dataIndex: 'curOrderSatisfyRate',
    scopedSlots: { customRender: 'curOrderSatisfyRate' }
  },
  {
    title: '增减货前-累计订单满足率',
    width: 180,
    dataIndex: 'beforeSumOrderSatisfyRate',
    scopedSlots: { customRender: 'beforeSumOrderSatisfyRate' }
  },
  {
    title: '增减货后-累计订单满足率',
    width: 180,
    dataIndex: 'sumOrderSatisfyRate',
    scopedSlots: { customRender: 'sumOrderSatisfyRate' }
  },
  {
    title: '当天欠货',
    width: 100,
    dataIndex: 'currentDayUnderShipmentQty'
  },
  {
    title: '7天欠货',
    width: 80,
    dataIndex: 'sevenDayUnderShipmentQty',
    scopedSlots: { customRender: 'sevenDayUnderShipmentQty' }
  },
  {
    title: '14天欠货',
    width: 80,
    dataIndex: 'fourteenDayUnderShipmentQty',
    scopedSlots: { customRender: 'fourteenDayUnderShipmentQty' }
  },
  {
    title: '存放区域',
    width: 100,
    dataIndex: 'depositAreaName',
    scopedSlots: { customRender: 'depositAreaName' }
  },
  {
    title: '增减货前-库位数',
    width: 120,
    dataIndex: 'beforeLocationQuantity',
    scopedSlots: { customRender: 'beforeLocationQuantity' }
  },
  {
    title: '增减货前-库位利用率',
    width: 140,
    dataIndex: 'beforeLocationUseRate',
    scopedSlots: { customRender: 'beforeLocationUseRate' }
  },
  {
    title: '增减货后-库位数',
    width: 120,
    dataIndex: 'locationQuantity',
    scopedSlots: { customRender: 'locationQuantity' }
  },
  {
    title: '增减货后-库位利用率',
    width: 140,
    dataIndex: 'locationUseRate',
    scopedSlots: { customRender: 'locationUseRate' }
  },
  // {
  //   title: '安排体积',
  //   width: 100,
  //   dataIndex: 'arrangeVolume',
  //   scopedSlots: { customRender: 'arrangeVolume' }
  // },
  // {
  //   title: '已安排数量',
  //   width: 100,
  //   dataIndex: 'arrangeQuantity',
  //   scopedSlots: { customRender: 'arrangeQuantity' }
  // },
  // {
  //   title: '剩余入库数量',
  //   width: 100,
  //   dataIndex: 'surplusInStockQuantity',
  //   scopedSlots: { customRender: 'surplusInStockQuantity' }
  // },
  // {
  //   title: '取消数量',
  //   width: 100,
  //   dataIndex: 'cancelQuantity',
  //   scopedSlots: { customRender: 'cancelQuantity' }
  // },
  {
    title: '采购员',
    width: 100,
    dataIndex: 'purchaseUserName',
    scopedSlots: { customRender: 'purchaseUserName' }
  },
  {
    title: '要求到货日',
    width: 100,
    dataIndex: 'requireDeliveryDay',
    scopedSlots: { customRender: 'requireDeliveryDay' }
  },
  {
    title: '是否单独（单工厂）',
    width: 150,
    dataIndex: 'supplierExclusiveIs',
    scopedSlots: { customRender: 'supplierExclusiveIs' }
  },
  {
    title: '入库仓库',
    width: 100,
    dataIndex: 'warehouseName',
    scopedSlots: { customRender: 'warehouseName' }
  },
  {
    title: '供应商仓',
    width: 140,
    dataIndex: 'factoryWarehouseName',
    scopedSlots: { customRender: 'factoryWarehouseName' }
  },
  // {
  //   title: '预设装载体积',
  //   width: 100,
  //   dataIndex: 'presetLoadVolume',
  //   scopedSlots: { customRender: 'presetLoadVolume' }
  // },
  {
    title: '标准库位套数',
    width: 100,
    dataIndex: 'qtyPerLocation',
    scopedSlots: { customRender: 'qtyPerLocation' }
  },
  {
    title: '入库优先级',
    width: 100,
    dataIndex: 'supplierPriorityLevel',
    scopedSlots: { customRender: 'supplierPriorityLevel' }
  }
]

// 初始 - 0; 10 - 已推送；15 - 安排中；20 - 已关闭；
export const COMPLETE_STATUS = {
  INITIAL: {
    KEY: 0,
    VALUE: '初始'
  },
  HAS_PUSHED: {
    KEY: 10,
    VALUE: '已推送'
  },
  IN_PROGRESS: {
    KEY: 15,
    VALUE: '安排中'
  },
  CLOSED: {
    KEY: 20,
    VALUE: '已关闭'
  }
}
// 10 - 创建；15 - 审核中；20 - 已审核；99 - 已作废
export const STATUS = {
  CREATED: {
    KEY: 10,
    VALUE: '创建'
  },
  AUDITING: {
    KEY: 15,
    VALUE: '审核中'
  },
  AUDITED: {
    KEY: 20,
    VALUE: '已审核'
  },
  VOIDED: {
    KEY: 99,
    VALUE: '已作废'
  }
}
function changeObjByKey(obj, key, val) {
  const value = {}
  for(const objKey in obj) {
    const item = obj[objKey]
    value[item[key]] = item[val]
  }
  return value
}
export const STATUS_MAP = changeObjByKey(STATUS, 'KEY', 'VALUE')
export const COMPLETE_STATUS_MAP = changeObjByKey(COMPLETE_STATUS, 'KEY', 'VALUE')
